/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface AssetStartEventOffsetEUMarker {
  width?: number,
  height?: number,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for stop(destination) of the trip
 *
 * ```typescript
 *  import {getAssetStartEventOffsetEUMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getAssetStartEventOffsetEUMarker({fillColor, width, height}),
 *    width  : width,
 *    height : height
 * }
 * ```
 */
export const getAssetStartEventOffsetEUMarker = ({
  fillColor = dlsColor('grey4'),
  width = 50,
  height = 48
}: AssetStartEventOffsetEUMarker) => {
  const svg = (`
    <svg width='${width}' height='${height}' viewBox='0 0 50 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='11.5' cy='24' r='10.75' fill='${fillColor}' stroke='white' stroke-width='1.5'/>
      <circle cx='11.5' cy='24' r='5' fill='white'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getAssetStartEventOffsetEUMarker;
